<template>
  <search class="block__search">
    <form action="/" method="get" class="container" @submit.prevent="onSubmit">
      <div class="block__search-inner">
        <label for="s" v-html="title" />
        <div class="group">
          <Icon icon="search" class="icon-search" />
          <input id="s" type="search" name="s" :placeholder="placeholder" v-model="inputTerm">
          <button class="btn" type="submit">
            <span v-html="button" />
            <Icon icon="arrow-right" />
          </button>
        </div>
      </div>
    </form>
  </search>
</template>

<script>
import Icon from "./Icon.vue";
import { defineComponent, inject, ref } from 'vue';

export default defineComponent( {
  name: 'SearchForm',
  components: {
    Icon
  },
  setup( props, { emit } ) {
    const { term, button, title, placeholder } = inject( 'searchForm' );

    // Use a separate ref for the input field, so that typing doesn't affect `term` directly
    const inputTerm = ref( term.value );

    // Handle form submission
    const onSubmit = ( event ) => {
      event.preventDefault();

      // Emit the input term to the parent component
      emit( 'update:searchTerm', inputTerm.value );

      // Optionally update the reactive term after submit
      term.value = inputTerm.value; // Sync input with actual `term` if needed
    };

    return {
      inputTerm,  // This is used for binding the search input
      button,
      title,
      placeholder,
      onSubmit
    };
  }
} );
</script>
